'use strict';

var _trvFedClient = require('./trv-fed-client');

var _trvFedClient2 = _interopRequireDefault(_trvFedClient);

var _reducer = require('./modules/reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _resources = require('./mocks/resources');

var _resources2 = _interopRequireDefault(_resources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _trvFedClient2.default)({
  reducer: _reducer2.default,
  mockedResources: __MOCK__ ? _resources2.default : undefined,
  logging: __DEVELOPMENT__
});


//////////////////
// WEBPACK FOOTER
// ./src/client.js
// module id = 1191
// module chunks = 0